export const metaDataQueryKeys = {
  all: ['meta-data'],
  general: ['meta-data', 'general'],
};
